import { useTranslations } from 'next-intl';
import { BodyLarge } from '@dh/styles';
import { DisplayProps } from '@mui/system';

export const MandatoryInputHint = (props: DisplayProps) => {
    const t_forms = useTranslations('forms');
    return <BodyLarge {...props}>{t_forms('mandatory_input')}</BodyLarge>;
};
